import { Box, Container, Stack, Text, Title } from "@repo/ui/core";
import { IconLock } from "@repo/ui/icons";

export function AccessDeniedPage() {
  return (
    <Box
      mih="100vh"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--mantine-color-dark-9)",
      }}
    >
      <Container size="xs">
        <Stack align="center" gap="lg">
          <IconLock size={48} style={{ color: "var(--mantine-color-dimmed)" }} />
          <Title order={2} ta="center">
            Access Required
          </Title>
          <Text c="dimmed" ta="center" size="sm">
            This content requires an access link. Please contact your Null Autos
            representative for an invitation.
          </Text>
        </Stack>
      </Container>
    </Box>
  );
}
